import { Box, Typography, Stack, IconButton } from '@mui/material';
// import { SvgIcon } from '@mui/material';
// import LinkIcon from '@mui/icons-material/Link';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { formattingDate } from 'shared/helpers/FormatDate';
import { IAttachment, IEvidenceTracking } from './ComplianceList';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

interface AttachmentListProps {
  evidenceTracking: IEvidenceTracking | undefined;
  onDelete?: (attachmentId: string, erlNumber: string) => void;
  onDownload?: (attachment: IAttachment) => void;
}

const AttachmentList: React.FC<AttachmentListProps> = ({
  evidenceTracking,
  onDelete,
  onDownload,
}) => {
  const attachments = evidenceTracking?.attachments || [];
  const erlNumber = evidenceTracking?.erl_number;

  return (
    <Box sx={{ mt: 4 }}>
      {attachments.map((attachment) => (
        <Box
          key={attachment._id}
          className="app-box-border"
          sx={{
            p: 2,
            mb: 2,
            borderRadius: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack direction="row" alignItems="center" spacing={1.5} flex={1}>
              {attachment.external_url ? (
                <OpenInNewOutlinedIcon
                  sx={{
                    color: 'text.secondary',
                  }}
                />
              ) : (
                <DescriptionOutlinedIcon
                  sx={{
                    color: 'text.secondary',
                  }}
                />
              )}
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  {attachment.file_name}
                </Typography>

                {/* Metadata */}
                <Stack direction="row" spacing={2} alignItems="center" mt={0.5}>
                  <Typography variant="caption" color="text.secondary">
                    {attachment.file_size || 0}
                  </Typography>

                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <CalendarTodayOutlinedIcon
                      sx={{
                        fontSize: 13,
                        color: 'text.secondary',
                      }}
                    />

                    <Typography variant="caption" color="text.secondary">
                      {formattingDate(attachment.created_at)}
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            </Stack>

            {/* Actions */}
            <Stack direction="row" spacing={0.5}>
              {onDownload && (
                <IconButton size="small" onClick={() => onDownload(attachment)}>
                  <DownloadIcon fontSize="small" />
                </IconButton>
              )}

              {onDelete && erlNumber && (
                <IconButton
                  size="small"
                  onClick={() => onDelete(attachment._id, erlNumber)}
                >
                  <DeleteIcon fontSize="small" sx={{ color: 'error.main' }} />
                </IconButton>
              )}
            </Stack>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default AttachmentList;
